import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../operations';

const initialState = null;

const slice = createSlice({
  name: '$tyroPaymentStatus',
  initialState,
  reducers: {
    setTyroPaymentStatus(state, action: PayloadAction<any>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, () => {
      return initialState;
    });
  },
});

export const { setTyroPaymentStatus } = slice.actions;
export default slice.reducer;
